module.exports = __webpack_public_path__ + "site-build/img/01logo_grey1.c9d5e3c8.png";